import React from 'react';
import ProductSidebarComponent from './ProductSidebarComponent';
import { PageHeader } from '../../components';

const TechnologyUpgradation: React.FC = () => {
  return (
    <>
      <PageHeader customClass='bg-breadcrumb-revamp' title="Technology Upgradation" breadcrumbs={[{ label: "Products", path: "/products" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-3.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Technology Upgradation</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>With evolving water treatment technologies and increasing demand for automation, industries and municipalities must continuously modernize their plants to remain efficient, compliant, and cost-effective. At Wasser Technochem (I) Ltd., we specialize in technology upgradation of water and wastewater treatment facilities, helping clients move from traditional systems to advanced, digitally integrated and high-performance technologies.</p>
              <p>From legacy plant automation to adopting next-generation biological and membrane processes, we ensure a seamless transformation with minimal disruption.</p>

              <h3 className="mb-4">Scope of Services</h3>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <p><i className="fa fa-exchange-alt text-primary me-2"></i>Replacement of obsolete technologies with modern, modular systems</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-leaf text-primary me-2"></i>Upgradation to energy-efficient equipment (pumps, blowers, mixers)</p>
                </div>
                <div className="col-md-12">
                  <h5><i className="fa fa-cogs text-primary me-2"></i>Integration of advanced treatment technologies:</h5>
                  <div className="ms-4">
                    <p><i className="fa fa-circle text-secondary me-2" style={{ fontSize: '8px' }}></i>UF/RO/MEE systems</p>
                    <p><i className="fa fa-circle text-secondary me-2" style={{ fontSize: '8px' }}></i>MBR, SBR, and tertiary polishing units</p>
                    <p><i className="fa fa-circle text-secondary me-2" style={{ fontSize: '8px' }}></i>Chemical dosing automation</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-microchip text-primary me-2"></i>Implementation of PLC/SCADA, IoT sensors, and remote dashboards</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-chart-line text-primary me-2"></i>Process redesign using latest water chemistry and modelling tools</p>
                </div>
                <div className="col-md-12">
                  <p><i className="fa fa-digital-tachograph text-primary me-2"></i>Digitalization of logs, performance reports, and alarm systems</p>
                </div>
              </div>

              <h3 className="mb-4">Example Technologies Upgraded</h3>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-flask text-primary me-2"></i>Chlorination Systems</h5>
                      <p>Manual chlorination to automated dosing with ORP feedback</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-air-freshener text-primary me-2"></i>Aeration Systems</h5>
                      <p>Basic aeration tanks to MBR with nutrient control</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-filter text-primary me-2"></i>RO Systems</h5>
                      <p>Conventional RO to low-pressure, high-recovery RO systems</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-mobile-alt text-primary me-2"></i>Monitoring Systems</h5>
                      <p>Paper logbooks to cloud-based monitoring and mobile alerts</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-brain text-primary me-2"></i>Smart Systems</h5>
                      <p>Integration and development of AI based Smart Water Treatment system</p>
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="mb-4">Benefits</h3>
              <div className="row g-4 mb-5">
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Improved Efficiency</h5>
                  <p>Improves plant efficiency and reduces OPEX</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Predictive Maintenance</h5>
                  <p>Enables predictive maintenance and fault alerts</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Digital Compliance</h5>
                  <p>Supports digital compliance and reporting</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Enhanced Safety</h5>
                  <p>Enhances safety and operational control</p>
                </div>
                <div className="col-md-12">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Future Ready</h5>
                  <p>Positions plants for future reuse and ESG goals</p>
                </div>
              </div>

              <h3 className="mb-4">Why WTIL?</h3>
              <div className="row g-4">
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-tools text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Dual Expertise</h5>
                      <p className="mb-0">Expertise in both mechanical and automation-driven upgrades</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-microchip text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>In-house Capability</h5>
                      <p className="mb-0">In-house capability for SCADA, PLC, and instrumentation systems</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-handshake text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Strong Partnerships</h5>
                      <p className="mb-0">Strong partnerships with OEMs and tech providers</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-calculator text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>ROI-based Selection</h5>
                      <p className="mb-0">Technology selection based on ROI and application fit</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-graduation-cap text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Comprehensive Support</h5>
                      <p className="mb-0">Post-upgrade handholding with training and tech support</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <ProductSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default TechnologyUpgradation;
